import script from "./RealTimeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTimeTable.vue?vue&type=script&setup=true&lang=js"

import "./RealTimeTable.vue?vue&type=style&index=0&id=79a40eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a40eea"]])

export default __exports__